module.exports = __webpack_public_path__ + "static/media/MC20.4342a284.png";